import type { SessionContext } from "../api/types";

export const CUSTOM_WORKFLOWS_FEATURE = "CUSTOM_WORKFLOWS";

export function hasCustomWorkflowsAccess(
  session: Pick<SessionContext, "features" | "featureTenantId" | "user" | "workspaceProduct">,
): boolean {
  if (session.workspaceProduct === "SIMPLE_BILLING") return false;
  if (!Array.isArray(session.features) || !session.features.includes(CUSTOM_WORKFLOWS_FEATURE)) return false;
  if (session.user.role !== "owner" && session.user.role !== "super_admin") return false;
  return session.user.role !== "super_admin" || Boolean(session.featureTenantId);
}

export function hasWorkflowProjectsAccess(
  session: Pick<SessionContext, "features" | "featureTenantId" | "user" | "workspaceProduct">,
): boolean {
  if (session.workspaceProduct === "SIMPLE_BILLING") return false;
  if (!Array.isArray(session.features) || !session.features.includes(CUSTOM_WORKFLOWS_FEATURE)) return false;
  return session.user.role !== "super_admin" || Boolean(session.featureTenantId);
}
